<div *ngIf="!showContent" class="loading-spinner">
    <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="showContent">
    <mat-tab-group>
        <mat-tab label="">        
            <form [formGroup]="detailsForm">
                <div class="tab-container">
                    <div class="tab-section">
                        <h2 style="background-color: rgb(125, 11, 160); color: white; text-align: center; font-size: 14px;" >
                            <i style="font-size: 15px;" class="fa-solid fa-info-circle"></i>&nbsp;PCES Client Details
                        </h2>
                        <div class="tab-grid-template">
                            <mat-form-field class="bigger-width">
                                <mat-label>Client Name</mat-label>
                                <input matInput formControlName="clientname">
                            </mat-form-field>
                            <mat-form-field class="bigger-width">
                                <mat-label>Client Number</mat-label>
                                <input matInput formControlName="clientnumber">
                            </mat-form-field>
                            <mat-form-field class="bigger-width">
                                <mat-label>Factoring For</mat-label>
                                <input matInput formControlName="factoringfor">
                            </mat-form-field>
                            <mat-form-field class="bigger-width">
                                <mat-label>Group Name</mat-label>
                                <input matInput formControlName="groupname">
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Short Name</mat-label>
                                <input matInput formControlName="clientshortname">
                            </mat-form-field>
                        </div>
                        <div style="display: flex; flex-wrap: wrap; width: 50%; gap: 10px;">
                            <button (click)="editDetails()" style="width: 100%; background-color: rgb(7, 170, 20); " mat-raised-button color="primary" [hidden]="editEnabled">
                                <i style="font-size: 15px;"  class="fas fa-edit"></i>&nbsp;Edit Details
                            </button>
                            <button (click)="saveClientDetails()" style="width: 100%; background-color: rgb(4, 71, 34); " mat-raised-button color="primary" [hidden]="!editEnabled">
                                <i style="font-size: 15px;"  class="fas fa-save"></i>&nbsp;Save Changes To Details
                            </button>
                        </div>                               
                    </div>
                    <div class="tab-section">
                        <h2 style="background-color: rgb(125, 11, 160); color: white; text-align: center; font-size: 14px;" >
                            <i style="font-size: 15px;" class="fa-solid fa-dollar"></i>&nbsp;PCES Client Banking Information
                        </h2>
                        <div class="tab-grid-template">
                            <mat-form-field>
                                <mat-label>Bank No</mat-label>
                                <input matInput formControlName="clientbankno">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Branch No</mat-label>
                                <input matInput formControlName="clientbranchno">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>ABA Routing No</mat-label>
                                <input matInput formControlName="clientabaroutingno">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Account No</mat-label>
                                <input matInput formControlName="clientaccountno">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Currency</mat-label>
                                <input matInput formControlName="clientcurrency">
                            </mat-form-field>                            
                        </div>
                    </div>
                    <div class="tab-section">
                        <h2 style="background-color: rgb(125, 11, 160); color: white; text-align: center; font-size: 14px;" >
                            <i style="font-size: 15px;" class="fa-solid fa-house"></i>&nbsp;PCES Client Address
                        </h2>
                        <div class="tab-grid-template">
                            <mat-form-field class="bigger-width">
                                <mat-label>Address</mat-label>
                                <input matInput formControlName="clientaddress">
                            </mat-form-field>
                            <mat-form-field class="bigger-width">
                                <mat-label>City</mat-label>
                                <input matInput formControlName="client_locality">
                            </mat-form-field>
                            <mat-form-field class="bigger-width">
                                <mat-label>Province</mat-label>
                                <input matInput formControlName="client_region">
                            </mat-form-field>                            
                            <mat-form-field class="bigger-width">
                                <mat-label>Postal Code</mat-label>
                                <input matInput formControlName="client_postal_code">
                            </mat-form-field>
                            <mat-form-field class="bigger-width">
                                <mat-label>Country</mat-label>
                                <input matInput formControlName="client_country">
                            </mat-form-field>
                        </div>
                        <div style="display: flex; flex-wrap: wrap; width: 50%; gap: 10px;">
                            <button (click)="deleteClient()" style="width: 100%; background-color: rgb(187, 7, 52); " mat-raised-button color="primary">
                                <i style="font-size: 15px;"  class="fas fa-trash"></i>&nbsp;Delete Client
                            </button>
                        </div>                        
                    </div>                    
                </div>
            </form>
        </mat-tab>
    </mat-tab-group>
</ng-container>